import script from "./SummaryReport.vue?vue&type=script&setup=true&lang=js"
export * from "./SummaryReport.vue?vue&type=script&setup=true&lang=js"

import "./SummaryReport.vue?vue&type=style&index=0&id=5050ec34&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5050ec34"]])

export default __exports__